import { useWalletStoreBase } from 'stores/wallet/wallet.store';
import type { CrossMarginMessage } from 'types/CrossMargin';
import type { MultiCollateralMessage } from 'types/MultiCollateral';
import type { PortfolioMargin } from 'types/PortfolioMargin';

const updatePortfolioMargin = (data: PortfolioMargin) => {
  useWalletStoreBase.getState().actions.updatePortfolioMargin(data);
};

const updateCrossMargin = (data: CrossMarginMessage) => {
  useWalletStoreBase.getState().actions.updateCrossMargin(data);
};

const updateMultiCollateral = (data: MultiCollateralMessage) => {
  useWalletStoreBase.getState().actions.updateMultiCollateral(data);
};

const updateWalletSpotPrices = (data: { s: string; p: string }) => {
  useWalletStoreBase.getState().actions.updateWalletSpotPrices(data);
};

export {
  updatePortfolioMargin,
  updateCrossMargin,
  updateMultiCollateral,
  updateWalletSpotPrices,
};
